import { ArrowRight } from 'lucide-react';
import { problem, rescue, contact } from '../../../content/agencyCopy';
import RevealOnScroll from '../RevealOnScroll';

export default function ProblemRescue() {
  return (
    <section
      className="fa-grid px-6 py-24 md:py-32"
      style={{
        background: 'var(--fa-signal-wash)',
        borderTop: '1px solid var(--fa-rule)',
        borderBottom: '1px solid var(--fa-rule)',
      }}
    >
      <RevealOnScroll className="max-w-[1120px] mx-auto">
        <div className="fa-label fa-header-rule mb-5">
          <span className="flex items-center gap-3">
            <span className="fa-status-dot fa-status-dot--live" aria-hidden="true" />
            The pattern
          </span>
        </div>
        <h2
          className="font-heading text-[30px] md:text-[42px] font-semibold"
          style={{ maxWidth: '20ch', color: 'var(--fa-ink)', textWrap: 'balance' }}
        >
          {problem.headline}
        </h2>
        {problem.body.map((p, i) => (
          <p
            key={i}
            className="mt-5 text-[16px] fa-glow-text fa-glow-text--muted"
            style={{ maxWidth: '62ch' }}
          >
            {p}
          </p>
        ))}

        <div className="fa-plate fa-ticks mt-14 grid md:grid-cols-2 gap-0 overflow-hidden"
             style={{ background: 'var(--fa-surface)' }}>

          <div
            className="p-8 md:p-10"
            style={{
              borderRight: '1px solid var(--fa-rule)',
              borderLeft: '3px solid var(--fa-signal)',
            }}
          >
            <div className="fa-label" style={{ color: 'var(--fa-muted)' }}>The problem</div>
            <div
              className="fa-mono font-bold mt-4"
              style={{
                color: 'var(--fa-signal)',
                fontSize: 'clamp(56px, 8vw, 84px)',
                lineHeight: 1,
              }}
            >
              {problem.stat.number}
            </div>
            <p
              className="mt-5 text-[15px] fa-glow-text"
              style={{ maxWidth: '38ch' }}
            >
              {problem.stat.body}
            </p>
            <p
              className="mt-6 fa-mono text-[11px]"
              style={{ color: 'var(--fa-muted)' }}
            >
              {problem.stat.source}
            </p>
          </div>

          <div className="p-8 md:p-10 flex flex-col">
            <div className="flex items-center justify-between">
              <span className="fa-ref fa-ref--signal">{rescue.ref}</span>
              <span className="fa-ref" style={{ fontSize: 9 }}>2 days</span>
            </div>
            <h3
              className="font-heading text-[24px] md:text-[28px] font-semibold mt-4 leading-snug"
              style={{ maxWidth: '20ch', color: 'var(--fa-ink)', textWrap: 'balance' }}
            >
              {rescue.headline}
            </h3>
            <p
              className="mt-4 text-[16px] flex-1 fa-glow-text fa-glow-text--muted"
              style={{ maxWidth: '48ch' }}
            >
              {rescue.body}
            </p>
            <div className="mt-8">
              <button
                type="button"
                className="fa-btn-ghost"
                data-cal-link={contact.calLink}
                data-cal-namespace={contact.calNamespace}
              >
                {rescue.cta} <ArrowRight size={15} />
              </button>
            </div>
          </div>
        </div>
      </RevealOnScroll>
    </section>
  );
}
